import "./index.scss";
import { CampaignSlider } from "../campaign-slider";
import { INSTRUCTION_LIST } from "./utils/content";
import { mapProductSliders } from "./utils/mappers";

export const ShopProducts = ({ products }) => {
  const sliderItems = mapProductSliders(products);

  return (
    <div className="shop-products">
      <div className="instruction-list">
        <div className="list-container">
          {INSTRUCTION_LIST.map(({ icon, text, alt }) => (
            <div className="instruction" key={text}>
              <img src={icon} alt={alt} />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
      {sliderItems.map(({ title, brands }) => (
        <div className="products-slider" key={title}>
          <CampaignSlider
            brands={brands}
            title={title}
            centered
            seeAll={false}
          />
        </div>
      ))}
    </div>
  );
};

/*
  image,
  brandName,
  info = null,
  linkTo,
  customUrl = null,
  customClassName = "",
*/
